<ion-header role="none">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="back()" attr.aria-label="{{ 'ARIA_LABEL_BACK' | translate }}">
                <ion-icon *ngIf="currentStep === firstStep" slot="icon-only" name="close-outline"></ion-icon>
                <ion-icon *ngIf="currentStep !== firstStep" slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-title mode="ios" role="heading">
            <span *ngIf="currentStep === SignupDetailSteps.ENTER_EMAIL"              [innerHTML]="'SIGNUP_DETAIL_TITLE_SIGN_UP' | translate"></span>
            <span *ngIf="currentStep === SignupDetailSteps.PARTICIPATION_CODE"  [innerHTML]="'SIGNUP_DETAIL_TITLE_FINISH_SIGN_UP' | translate"></span>
            <span *ngIf="currentStep === SignupDetailSteps.RETRIEVE_EMAIL"      [innerHTML]="'SIGNUP_DETAIL_TITLE_RESEND_CODE' | translate"></span>
            <span *ngIf="currentStep === SignupDetailSteps.ENTER_RETRIEVED_CODE" [innerHTML]="'SIGNUP_DETAIL_TITLE_FINISH_SIGN_IN' | translate"></span>
        </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ENTER EMAIL - UNUSED INVITATION CODE
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <div *ngIf="currentStep === SignupDetailSteps.ENTER_EMAIL" class="container-sm">
        <h6 [innerHTML]="'SIGNUP_DETAIL_ENTER_EMAIL' | translate"></h6>
        <form (ngSubmit)="onSubmitEmail(false)" class="form-wrapper">
            <ion-item class="item-outline">
                <ion-input
                    clearInput
                    inputmode="email"
                    [(ngModel)]="email"
                    name="email"
                    placeholder="{{'SIGNUP_DETAIL_INPUT_PLACEHOLDER_EMAIL' | translate}}"
                    maxlength="100"
                    (ionFocus)="onInputFocus()"
                    (ionBlur)="onInputBlur()"
                >
                </ion-input>

            </ion-item>

            <h6 class="ion-text-center" *ngIf="processingCodeError">
                <span *ngIf="connectionFailed"  [innerHTML]="'AUTH_ERROR_CONNECTION_FAILED' | translate"></span>
                <span *ngIf="codeIsBad"         [innerHTML]="'AUTH_ERROR_INVALID' | translate"></span>
                <span *ngIf="unknownIssue"      [innerHTML]="'AUTH_ERROR_UNKNOWN' | translate"></span>
                <span *ngIf="invalidEmail"      [innerHTML]="'AUTH_ERROR_INVALID_EMAIL' | translate"></span>
            </h6>

            <ion-button expand="block" class="button-floating emphasized-button" type="submit" [disabled]="!email || !email.length || submitDisabled" [innerHTML]="'SIGNUP_DETAIL_BUTTON_SUBMIT' | translate"></ion-button>
        </form>

        <!-- <h6 class="footer-prompt ion-text-center" *ngIf="activeSlide === 'email'">Having trouble? <span class="text-underline" (click)="onClickContactUs()">Contact us</span></h6> -->
    </div>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ENTER PARTICIPATION CODE - USED OR UNUSED INVITATION CODE
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <div *ngIf="currentStep === SignupDetailSteps.PARTICIPATION_CODE" class="container-sm">
        <div *ngIf="alreadyActivated === false">
            <h6 *ngIf="translationData && translationData.email !== null" [innerHTML]="'SIGNUP_DETAIL_NEW_CODE_SENT' | translate:translationData"></h6>
            <h6 [innerHTML]="'SIGNUP_DETAIL_ENTER_NEW_CODE' | translate"></h6>
            <h6 [innerHTML]="'SIGNUP_DETAIL_KEEP_CODE' | translate"></h6>
            <h6 [innerHTML]="'SIGNUP_DETAIL_SPAM' | translate"></h6>
        </div>
        <div *ngIf="alreadyActivated === true">
            <h6 [innerHTML]="'SIGNUP_DETAIL_CODE_ALREADY_USED' | translate:translationData"></h6>
            <h6 [innerHTML]="'SIGNUP_DETAIL_ENTER_CORRECT_CODE' | translate"></h6>
        </div>

        <form (ngSubmit)="onSubmitParticipationCode()" class="form-wrapper">
            <ion-item class="item-outline">
                <ion-input
                    clearInput
                    type="text"
                    inputmode="text"
                    [(ngModel)]="participationCode"
                    name="participationCode"
                    placeholder="{{'SIGNUP_DETAIL_INPUT_PLACEHOLDER_CODE' | translate}}"
                    maxlength="100"
                    (ionFocus)="onInputFocus()"
                    (ionBlur)="onInputBlur()"
                >
                </ion-input>
            </ion-item>

            <h6 class="ion-text-center" *ngIf="processingCodeError">
                <span *ngIf="connectionFailed"  [innerHTML]="'AUTH_ERROR_CONNECTION_FAILED' | translate"></span>
                <span *ngIf="codeIsBad"         [innerHTML]="'AUTH_ERROR_INVALID' | translate"></span>
                <span *ngIf="unknownIssue"      [innerHTML]="'AUTH_ERROR_UNKNOWN' | translate"></span>
                <span *ngIf="invalidEmail"      [innerHTML]="'AUTH_ERROR_INVALID_EMAIL' | translate"></span>
            </h6>

            <ion-button expand="block" class="emphasized-button button-floating" type="submit" [disabled]="!participationCode || !participationCode.length || submitDisabled" [innerHTML]="'SIGNUP_DETAIL_BUTTON_ENTER' | translate"></ion-button>
        </form>

        <!-- <div class="footer-prompt ion-text-center">
            <h6 *ngIf="activeSlide === 'participationCode' && alreadyActivated === false">Didn't receive a code? <span class="text-underline">Try again</span>&nbsp;&nbsp;<span class="text-underline" (click)="onClickContactUs()">Contact us</span></h6>
            <h6 *ngIf="activeSlide === 'participationCode' && alreadyActivated === true">Click <span class="text-underline" (click)="onClickRetrieveCode()">here</span> to retreive your code by email.</h6>
        </div> -->
    </div>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    RETRIEVE CODE - USED INVITATION CODE OR NO INVITATION CODE
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <div *ngIf="currentStep === SignupDetailSteps.RETRIEVE_EMAIL" class="container-sm">
        <h6 [innerHTML]="'SIGNUP_DETAIL_ENTER_EMAIL_TO_RETRIEVE' | translate"></h6>
        <!-- <h6>You'll use this <strong>participation code</strong> for any future logins.</h6> -->

        <form (ngSubmit)="onSubmitEmail(true)" class="form-wrapper">
            <ion-item class="item-outline">
                <ion-input
                    clearInput
                    inputmode="email"
                    [(ngModel)]="email"
                    name="email"
                    placeholder="{{'SIGNUP_DETAIL_INPUT_PLACEHOLDER_EMAIL' | translate}}"
                    maxlength="100"
                >
                </ion-input>
            </ion-item>

            <h6 class="ion-text-center" *ngIf="processingCodeError">
                <span *ngIf="connectionFailed"  [innerHTML]="'AUTH_ERROR_CONNECTION_FAILED' | translate"></span>
                <span *ngIf="codeIsBad"         [innerHTML]="'AUTH_ERROR_INVALID' | translate"></span>
                <span *ngIf="unknownIssue"      [innerHTML]="'AUTH_ERROR_UNKNOWN' | translate"></span>
                <span *ngIf="invalidEmail"      [innerHTML]="'AUTH_ERROR_INVALID_EMAIL' | translate"></span>
            </h6>

            <ion-button expand="block" class="emphasized-button button-floating" type="submit" [disabled]="!email || !email.length || submitDisabled" [innerHTML]="'SIGNUP_DETAIL_BUTTON_SUBMIT' | translate"></ion-button>
        </form>

        <!-- <h6 class="footer-prompt ion-text-center">Having trouble? <span class="text-underline" (click)="onClickContactUs()">Contact us</span></h6> -->
    </div>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ENTER RETRIEVED CODE
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <div *ngIf="currentStep === SignupDetailSteps.ENTER_RETRIEVED_CODE" class="container-sm">
        <h6 *ngIf="translationData && translationData.email !== null" [innerHTML]="'SIGNUP_DETAIL_RETRIEVED_CODE_SENT' | translate:translationData"></h6>
        <form (ngSubmit)="onSubmitParticipationCode()">
            <ion-item class="item-outline">
                <ion-input
                    clearInput
                    type="text"
                    inputmode="text"
                    [(ngModel)]="participationCode"
                    name="participationCode"
                    placeholder="{{'SIGNUP_DETAIL_INPUT_PLACEHOLDER_CODE' | translate}}"
                    maxlength="100"
                >
                </ion-input>
            </ion-item>

            <h6 class="ion-text-center" *ngIf="processingCodeError">
                <span *ngIf="connectionFailed"  [innerHTML]="'AUTH_ERROR_CONNECTION_FAILED' | translate"></span>
                <span *ngIf="codeIsBad"         [innerHTML]="'AUTH_ERROR_INVALID' | translate"></span>
                <span *ngIf="unknownIssue"      [innerHTML]="'AUTH_ERROR_UNKNOWN' | translate"></span>
                <span *ngIf="invalidEmail"      [innerHTML]="'AUTH_ERROR_INVALID_EMAIL' | translate"></span>
            </h6>

            <ion-button expand="block" class="emphasized-button button-floating" type="submit" [disabled]="!participationCode || !participationCode.length || submitDisabled" [innerHTML]="'SIGNUP_DETAIL_BUTTON_SUBMIT' | translate"></ion-button>
        </form>

        <!-- <h6 class="footer-prompt ion-text-center">Having trouble? <span class="text-underline" (click)="onClickContactUs()">Contact us</span></h6> -->
    </div>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <span *ngIf="currentStep === SignupDetailSteps.PARTICIPATION_CODE">
            <div class="footer-prompt ion-text-center">
                <h6 *ngIf="alreadyActivated === false">
                    <span [innerHTML]="'SIGNUP_DETAIL_DIDNT_RECEIVE_CODE' | translate"></span>
                    <button class="link-button text-margin-left" (click)="onClickContactUs()" [innerHTML]="'SIGNUP_DETAIL_CONTACT_US' | translate"></button>
                </h6>
                <h6 *ngIf="alreadyActivated === true">
                    <button class="link-button text-margin-right" (click)="onClickRetrieveCode()" [innerHTML]="'SIGNUP_DETAIL_CLICK_HERE' | translate"></button>
                    <span [innerHTML]="'SIGNUP_DETAIL_TO_RETRIEVE' | translate"></span>
                </h6>
            </div>
        </span>
        <span *ngIf="currentStep === SignupDetailSteps.RETRIEVE_EMAIL || currentStep === SignupDetailSteps.ENTER_RETRIEVED_CODE || currentStep === SignupDetailSteps.ENTER_EMAIL">
            <h6 class="footer-prompt ion-text-center">
                <span [innerHTML]="'SIGNUP_DETAIL_HAVING_TROUBLE' | translate"></span>
                <button class="link-button text-margin-left" (click)="onClickContactUs()" [innerHTML]="'SIGNUP_DETAIL_CONTACT_US' | translate"></button>
            </h6>
        </span>
    </ion-toolbar>
</ion-footer>